import type { SVGProps } from 'react';

const BackHomeLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32px"
    height="26px"
    viewBox="0 0 32 26"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>My home marker</title>
    <defs>
      <path
        d="M24.6449997,9.86315789 L19.6,5.19649123 C19.2444444,4.93450292 18.7555556,4.93450292 18.4,5.19649123 L13.3550003,9.86315789 C13.1296675,10.0500108 12.9997594,10.3250424 13,10.6147368 L13,18.0175439 C13,18.5601394 13.4477156,19 14,19 L24,19 C24.5522844,19 25,18.5601394 25,18.0175439 L25,10.6147368 C25.0002406,10.3250424 24.8703325,10.0500108 24.6449997,9.86315789 Z"
        id="backHomeLeft-path-1"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-113.000000, -947.000000)">
        <g transform="translate(108.000000, 899.000000)">
          <g transform="translate(0.000000, 48.000000)">
            <g transform="translate(5.000000, 0.000000)">
              <path
                d="M19,26 C26.1797017,26 32,20.1797017 32,13 C32,5.82029825 26.1797017,0 19,0 C14.2135322,0 7.88019884,4.33333333 -5.29354338e-13,13 C7.88019884,21.6666667 14.2135322,26 19,26 Z"
                fill="#006AFF"
              />
              <use fill="#FFFFFF" fillRule="nonzero" href="#backHomeLeft-path-1" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BackHomeLeft;
